import axios from "axios";
import cookie from "react-cookies";
import SnackbarUtils from "../components/NotistackPlus";
import { RIMS_COOKIE_STG_CONSTANTS, RIMS_LOCAL_STG_CONSTANTS } from "../constants";
import { useConfigStore } from "../store/config";
// import { toast } from 'react-toastify';

// const isPrd = process.env.NODE_ENV === 'production';

//export const basicUrl = isPrd ? 'https://88xqd6km6b.execute-api.us-east-1.amazonaws.com' : 'http://localhost:3000/api'

export const basicUrl = process.env.REACT_APP_API_GETWAY;
export const adminCenterBasicUrl = process.env.REACT_APP_API_GETWAY_ADMIN_CENTER;
const refreshURL = "/common-auth/refresh";

const service = axios.create({
  baseURL: basicUrl,
});

service.interceptors.request.use(
  (config) => {
    const language = useConfigStore.getState()?.language;
    const languageformat = language === "en" ? "" : language;
    let token = cookie.load(RIMS_COOKIE_STG_CONSTANTS.LOGIN_TOKEN);
    // let token = 'eyJraWQiOiIzWDJlM1JaSGpMQU9CZXhLRTMzRkhNcGJscVdFZFp4ZCtqRXArSXpUNFc4PSIsImFsZyI6IlJTMjU2In0.eyJzdWIiOiJjOWUzMTU1NC0yZmNlLTQ1NzItOGNmMC1hZDM1YjdjMWVmMTMiLCJjb2duaXRvOmdyb3VwcyI6WyJ0ZW5hbnRfMCJdLCJpc3MiOiJodHRwczpcL1wvY29nbml0by1pZHAudXMtZWFzdC0xLmFtYXpvbmF3cy5jb21cL3VzLWVhc3QtMV9Senh2RWFwOXQiLCJjbGllbnRfaWQiOiIxa2U5aDVmYmlhbG1ndXFodXFkb3Bqa2M4dCIsIm9yaWdpbl9qdGkiOiI0M2ViNDE5Mi1mMGM3LTQ0ZDktYWNhNS01ZmI3ODExZGVlZWQiLCJldmVudF9pZCI6IjUzOTZjNmI2LTU0MzAtNDA4Mi1iYzFiLTcyZWJhYTlmNzRhZCIsInRva2VuX3VzZSI6ImFjY2VzcyIsInNjb3BlIjoiYXdzLmNvZ25pdG8uc2lnbmluLnVzZXIuYWRtaW4iLCJhdXRoX3RpbWUiOjE3MTU4MjgyNjQsImV4cCI6MTcxNTkxNDY2NCwiaWF0IjoxNzE1ODI4MjY0LCJqdGkiOiIxNDU4ODIxMi1iNmQzLTQ5NzctYTVhNy04MDIxYWQzMTYzMDEiLCJ1c2VybmFtZSI6InN1cGVycm9vdCJ9.MKAl5hZlhUZIH_deWAYk-4M1ORGFQ9lc6zLNrzZjHog-oIjM9fVYrsHul1slxy4lMAm7mjhcAsN7wWmhFB40C7J_z5O7VWkFGtWV1zE1FgeXZkh0rkEuHmWHnNuor0kQKNOo8WUOzvdXrJkikVJuX9dvHVw9F54A8yBGsuoyc3r3DB-N7pC8ggkiTWG3ou8knQYx8x-ReFNMmmUz4Ly8bDEWPdZLQ07R_y9oW9r-dR455Id0RIVk1Be6L4HbMRP7el0GjFuiy4Rkf4lzBE9S0VYGb4zoyL3UMyVEtnZNeK-yLSe4zNJvP2El9karmmHVFEJWR5acIEUwshe6j_Mlcw'
    // config.withCredentials = true;
    token
      ? (config.headers = {
        "Content-Type":
          config.responseType === "arraybuffer" &&
            JSON.stringify(config.data) === "{}"
            ? "application/octet-stream;charset=utf-8"
            : "application/json;charset=utf-8",
        Authorization: `Bearer ${token}`,
        "Accept-Language": languageformat || ""
      })
      : (config.headers = {
        "Content-Type": "application/json;charset=utf-8",
      });
    // config.data = QS.stringify(config.data)
    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);

service.interceptors.response.use(
  (response: any) => {
    if (response.config.responseType !== "arraybuffer") {
      if (response.status) {
        switch (response.status) {
          case 200:
            return response.data;
          case 400:
          case 401:
          case 403:
            if (response.config?.url?.indexOf(refreshURL) > -1) {
              // logoutFunction();
              // window.location.href = window.location.origin;
              console.log(
                "I catch err refreshURL 401/400/403 in request. will return"
              );
            }
            return;
          default:
            console.log("error", response.data.msg);
        }
      }
    } else {
      return response;
    }
  },
  (err) => {
    if (err.config?.url?.indexOf(refreshURL) > -1) {
      // logoutFunction();
      // console.log("I catch err refreshURL 401. will return");
      // window.location.href = window.location.origin;
      return;
    } else {
      switch (err.response.status) {
        case 401:
          console.log("I catch err 401. will return");
          break;
        case 403:
          break;
        case 500:
          if (localStorage.getItem(RIMS_LOCAL_STG_CONSTANTS.LOGIN_TOKEN)) {
            SnackbarUtils.error(
              "There is something wrong with server, please try again later"
            );
          }
          break;
        default:
        // SnackbarUtils.error('There is something wrong with server, please try again later')
      }
    }
    return Promise.reject(err);
  }
);

export default service;

export const adminCenterService = axios.create({
  baseURL: adminCenterBasicUrl,
});
